import {fetch} from '../../utils/dataAccess';

export function error(error) {
  return { type: 'CANDIDATE_COMPANY_SHOW_ERROR', error };
}

export function loading(loading) {
  return { type: 'CANDIDATE_COMPANY_SHOW_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'CANDIDATE_COMPANY_SHOW_SUCCESS', retrieved };
}

export function retrieve(id) {
  return dispatch => {
    dispatch(loading(true));

    return fetch(id)
      .then(response => response.data)
      .then((retrieved) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch({ type: 'CANDIDATE_COMPANY_SHOW_RESET' });
  };
}
